import QuizProgress from './QuizProgress';
import QuizNavigation from './QuizNavigation';

const QuizQuestion = ({ question, questionIndex, totalQuestions, selectedAnswer, onSelectAnswer, onBack, onNext }) => {
  return (
    <div className="flex min-h-[500px] flex-col">
      <div className="mb-8">
        <QuizProgress total={totalQuestions} current={questionIndex} />
      </div>

      <div className="flex flex-1 flex-col items-center">
        <div className="mb-4 text-[36px] leading-[39px] font-semibold tracking-[-1.08px] uppercase">
          {questionIndex + 1}.
        </div>
        <div className="mb-8 text-center text-[20px] leading-normal font-medium">{question.question}</div>

        <div className="flex w-full flex-col gap-[23px]">
          {(question.answers || []).map((answer) => (
            <button
              key={answer.id}
              type="button"
              onClick={() => onSelectAnswer(answer.value)}
              className={`min-h-[70px] w-full cursor-pointer rounded-[60px] px-10 py-4 text-center text-[16px] font-medium transition-colors ${
                selectedAnswer === answer.value ? 'bg-brand-400 text-white' : 'bg-white text-black hover:bg-white/90'
              }`}
            >
              {answer.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-8">
        <QuizNavigation showBack={questionIndex > 0} canGoNext={!!selectedAnswer} onBack={onBack} onNext={onNext} />
      </div>
    </div>
  );
};

export default QuizQuestion;
